// 格式化日期函数 - 将时间戳或日期字符串转换为 YYYY-MM-DD 格式
export const formatDate = (dateStr) => {
  if (!dateStr) return '2025-01-06';

  try {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '2025-01-06';
  }
};

// 生成随机播放量
export const generateRandomViews = () => {
  return Math.floor(Math.random() * 3000) + 500; // 500-3500 之间的随机数
};

// 生成随机时长（格式：MM:SS）
export const generateRandomDuration = () => {
  const minutes = Math.floor(Math.random() * 40) + 5; // 5-45 分钟
  const seconds = Math.floor(Math.random() * 60);
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

// 将秒数转换为 MM:SS 格式
export const formatSecondsToMMSS = (seconds) => {
  if (!seconds || seconds < 0) return '00:00';
  
  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};